"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var flattenDeep = require('lodash/flattenDeep');

var _require = require('../../../products/interfaces'),
    PaperComponent = _require.PaperComponent;

var _require2 = require('../../../products/components'),
    TableNumber = _require2.TableNumber,
    WaxSeal = _require2.WaxSeal,
    VellumJacket = _require2.VellumJacket,
    RibbonSpool = _require2.RibbonSpool,
    RibbonSample = _require2.RibbonSample;

var Highlight = require('./Highlight');

function TableNumbersShipment(_ref) {
  var shipment = _ref.shipment;
  var shipping_address = shipment.shipping_address,
      products = shipment.products,
      notes = shipment.notes;
  var firstname = shipping_address.firstname,
      lastname = shipping_address.lastname,
      street1 = shipping_address.street1,
      street2 = shipping_address.street2,
      city = shipping_address.city,
      state = shipping_address.state,
      postalCode = shipping_address.postalCode,
      country = shipping_address.country;
  var address_formatted = ["".concat(firstname, " ").concat(lastname), "".concat(street1), street2 ? "".concat(street2) : '', "".concat(city, ", ").concat(state, " ").concat(postalCode), country === 'US' ? '' : "".concat(country)].filter(function (a) {
    return a;
  }).map(function (str) {
    return /*#__PURE__*/React.createElement("span", {
      key: str
    }, str, /*#__PURE__*/React.createElement("br", null));
  });
  var products_formatted = flattenDeep(products.map(function (product) {
    return product.components.map(function (component, index) {
      var ink_colors = product.ink_colors,
          paper_type = product.paper_type,
          design_name = product.design_name;
      var quantity = component.quantity,
          product_size = component.product_size,
          wax_seal_style = component.wax_seal_style,
          ribbon_spool_color = component.ribbon_spool_color;
      var arr = [quantity];
      var key = design_name + index;

      if (Object.prototype.isPrototypeOf.call(PaperComponent.prototype, component)) {
        arr.push(Object.prototype.isPrototypeOf.call(TableNumber.prototype, component) ? design_name : "".concat(design_name, " (Signs)"));
        arr.push(ink_colors.join(','));
        arr.push(paper_type);
        arr.push("".concat(product_size, "\""));
        return /*#__PURE__*/React.createElement("strong", {
          key: key
        }, arr.join(' - '), /*#__PURE__*/React.createElement("br", null));
      }

      if (Object.prototype.isPrototypeOf.call(WaxSeal.prototype, component)) {
        arr.push("".concat(wax_seal_style, " Wax Seals"));
        return /*#__PURE__*/React.createElement("strong", {
          key: key
        }, arr.join(' - '), /*#__PURE__*/React.createElement("br", null));
      }

      if (Object.prototype.isPrototypeOf.call(VellumJacket.prototype, component)) {
        arr.push('Vellum Jackets');
        return /*#__PURE__*/React.createElement("strong", {
          key: key
        }, arr.join(' - '), /*#__PURE__*/React.createElement("br", null));
      }

      if (Object.prototype.isPrototypeOf.call(RibbonSpool.prototype, component)) {
        arr.push('Ribbon');
        arr.push(ribbon_spool_color);
        return /*#__PURE__*/React.createElement(Highlight, {
          key: key
        }, /*#__PURE__*/React.createElement("strong", null, arr.join(' - '), /*#__PURE__*/React.createElement("br", null)));
      }

      if (Object.prototype.isPrototypeOf.call(RibbonSample.prototype, component)) {
        arr.push('Ribbon Sample');
        arr.push(ribbon_spool_color);
        return /*#__PURE__*/React.createElement("strong", {
          key: key
        }, arr.join(' - '), /*#__PURE__*/React.createElement("br", null));
      }

      return null;
    });
  }));
  return /*#__PURE__*/React.createElement("span", null, address_formatted, products_formatted, shipment.service, /*#__PURE__*/React.createElement("br", null), notes.map(function (_ref2, i) {
    var text = _ref2.text;
    return /*#__PURE__*/React.createElement(Highlight, {
      key: i
    }, "Note: ", text, /*#__PURE__*/React.createElement("br", null));
  }));
}

TableNumbersShipment.propTypes = {
  shipment: PropTypes.shape({
    products: PropTypes.array.isRequired,
    shipping_address: PropTypes.shape({
      firstname: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
      street1: PropTypes.string.isRequired,
      street2: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      postalCode: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired
    }).isRequired,
    service: PropTypes.string.isRequired,
    notes: PropTypes.array.isRequired
  }).isRequired
};
module.exports = TableNumbersShipment;